import axios from 'axios';

const API_URL = process.env.VUE_APP_URL;

class APIService{
    get(url){
        return axios.get(API_URL + url)
    }
    post(url, data){
        return axios.post(API_URL + url, data)
    }
}

export default new APIService();
